import { parsePickerDateUtcStrict, parseUtcStrict } from './parseStoredDate';

export const isValidPickerDateString = (dateString: string): boolean => parsePickerDateUtcStrict(dateString).isValid();

export const getFormattedDateForPicker = (date: string | Date): string => {
  if (!date) {
    return '';
  }

  const parsed = date instanceof Date ? parseUtcStrict(date) : parsePickerDateUtcStrict(date);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss.SSSSSSZZ') : '';
};

export const safeFormatDateForDisplay = (date: string | null | undefined): string => {
  if (!date) {
    return '';
  }

  const parsed = parseUtcStrict(date);
  return parsed.isValid() ? parsed.format('MM/DD/YYYY') : '';
};
